import { type FC, type ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Divider } from 'base-ui'

import { StaticImage } from '../../../../../image'
import ImgErxItem from '../../../../images/ImgErxItem.png'

import { ErxBonusLandingPageHowBonusIsCalculatedInfoStepsV1 } from './ErxBonusLandingPageHowBonusIsCalculatedInfoSteps'

const accentuate = (text: ReactNode[]): ReactNode => {
  return <span className="text-dark-primary-strong">{text}</span>
}

export const ErxBonusLandingPageHowBonusIsCalculatedExampleV1: FC = () => {
  const intl = useIntl()

  return (
    <div className="flex flex-1 flex-col gap-4">
      <div className="flex items-start gap-4 rounded-lg bg-light-primary-low p-6">
        <StaticImage
          alt={intl.formatMessage({
            id: 'deErx.bonus.howBonusIsCalculated.example.item.name',
          })}
          className="size-12 object-contain tablet:size-16"
          height={64}
          src={ImgErxItem}
          width={64}
        />

        <div className="flex w-full flex-col gap-4">
          <div className="flex flex-col">
            <span className="text-xl font-medium">
              <FormattedMessage id="deErx.bonus.howBonusIsCalculated.example.item.name" />
            </span>
            <span className="">
              <FormattedMessage
                id="deErx.bonus.howBonusIsCalculated.example.item.owner"
                values={{
                  accentuate,
                }}
              />
            </span>
          </div>
          <ErxBonusLandingPageHowBonusIsCalculatedInfoStepsV1 />
        </div>
      </div>

      <div className="flex flex-col gap-4 rounded-lg bg-light-primary-low p-6">
        <span className="text-m font-medium">
          <FormattedMessage id="deErx.bonus.howBonusIsCalculated.example.title" />
        </span>

        <div className="flex flex-col gap-3">
          <div className="flex justify-between gap-4">
            <span className="">
              <FormattedMessage id="deErx.bonus.howBonusIsCalculated.example.copayment.title" />
            </span>
            <span>
              <FormattedMessage id="deErx.bonus.howBonusIsCalculated.example.copayment.amount" />
            </span>
          </div>

          <Divider />

          <div className="flex justify-between gap-4">
            <span className="">
              <FormattedMessage id="deErx.bonus.howBonusIsCalculated.example.subtotal.title" />
            </span>
            <span>
              <FormattedMessage id="deErx.bonus.howBonusIsCalculated.example.subtotal.amount" />
            </span>
          </div>

          <div className="flex items-center justify-between gap-4">
            <span className="font-medium italic text-dark-brand">
              <FormattedMessage id="deErx.bonus.howBonusIsCalculated.example.bonus.title" />
            </span>
            <span className="rounded-full bg-light-tertiary px-4 py-1 text-m font-medium tablet:text-l">
              <FormattedMessage id="deErx.bonus.howBonusIsCalculated.example.bonus.amount" />
            </span>
          </div>

          <Divider />

          <div className="flex justify-between gap-4 font-medium">
            <span className="text-m">
              <FormattedMessage id="deErx.bonus.howBonusIsCalculated.example.total.title" />
            </span>
            <span>
              <FormattedMessage id="deErx.bonus.howBonusIsCalculated.example.total.amount" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
